export default __webpack_public_path__ + "static/media/websiteLogo.2c1108a8.svg";